import React, { PropTypes } from 'react';
import { FormattedMessage } from 'react-intl';
import { CheckedOutIcon } from '@bibliocommons/base-icons';
import BorrowingEmptyContentPanel from '../../shared/BorrowingEmptyContentPanel';

import './CheckedOutEmptyContentPanel.scss';

export default function CheckedOutEmptyContentPanel({ fetching }) {
  return (
    <BorrowingEmptyContentPanel
      className="cp-checked-out-empty-content-panel"
      icon={<CheckedOutIcon />}
      showExploreNewTitlesLink
      fetching={fetching}
      title={<FormattedMessage id="checkedout_empty_title" />} />
  );
}

CheckedOutEmptyContentPanel.propTypes = {
  fetching: PropTypes.bool
};



// WEBPACK FOOTER //
// ./app/components/borrowing/checkouts/CheckedOutEmptyContentPanel/CheckedOutEmptyContentPanel.jsx